import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./Layout/Layout";
import Home from "./Home/Home";
import Chart from "./Home/Chart";
import Sattachart from "./Home/Sattachart";
import Allmarket from "./Home/Allmarket";
import Privacypolicy from "./Home/Privacypolicy";
import TermsConditions from "./Home/Termsandcondition";
import Markets from "./Home/Markets";
import Contact from "./Home/Contact";
import Login from "./Home/Login";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              <>
                <Home />
                <Chart />
                <Allmarket />
              </>
            }
          />

          <Route path="chart" element={<Sattachart />} />

          <Route path="contact" element={<Contact />} />

          <Route path="login" element={<Login />} />

          <Route path="markets" element={<Markets />} />

          <Route path="privacypolicy" element={<Privacypolicy />} />

          <Route path="termsconditions" element={<TermsConditions />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
